import Button from '@wg/wows-react-uikit/Button'
import Currency from '@wg/wows-react-uikit/Currency'
import DivTooltip from '@wg/wows-react-uikit/DivTooltip'
import Message from '@wg/wows-react-uikit/Message'
import StepCSSTransitionGroup from '@wg/wows-react-uikit/StepCSSTransitionGroup'
import TooltipBody from '@wg/wows-react-uikit/TooltipBody'
import classnames from 'classnames'
import { t, x } from 'helpers/localization'
import moment from 'moment'
import React, { Component } from 'react'
import { Interpolate } from 'react-i18next'
import styles from './RegularReward.scss'

export default class RegularReward extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.isAvailable !== nextProps.isAvailable ||
            this.props.haveEnoughMoney !== nextProps.haveEnoughMoney ||
            this.props.isPending !== nextProps.isPending ||
            this.props.lastReceive !== nextProps.lastReceive ||
            this.props.needOil !== nextProps.needOil ||
            this.props.members.length !== nextProps.members.length
    }

    static secToDays = (sec: number): number => {
        return sec / 60 / 60 / 24
    }

    static getNewPlayerNames = (members) => {
        return members.filter(member => member.daysInClan < 14).map(member => member.name)
    }

    renderBuyButtonTooltip = (cooldown, haveEnoughMoney, needOil) => {
        const hasCooldown = cooldown > 0

        if (!haveEnoughMoney) {
            return (
                <TooltipBody>
                    <Message type="danger" style="inline">
                        <div className={styles.noMoneyError}>
                            <Interpolate
                                i18nKey={x('Не хватает: %(oil)s')}
                                t={t}
                                oil={(
                                    <Currency
                                        isBold
                                        type="oil"
                                        amount={needOil}
                                    />
                                )}
                            />
                        </div>
                    </Message>
                </TooltipBody>
            )
        } else if (hasCooldown) {
            return (
                <TooltipBody>
                    <Message type="danger" style="inline">
                        <div className={styles.noMoneyError}>
                            <Interpolate
                                i18nKey={x('Доступен через %(days)s д.')}
                                days={cooldown}
                                t={t}
                            />
                        </div>
                    </Message>
                </TooltipBody>
            )

        }

        return null

    }

    render() {
        const {
            title,
            description,
            price,
            isAvailable,
            haveEnoughMoney,
            onBuy,
            isPending,
            index,
            needOil,
            offerId,
            canDistribute
        } = this.props

        const interval = RegularReward.secToDays(this.props.requirements.delay)
        let cooldown = 0
        if (this.props.lastReceive) {
            const now = moment()
            const lastReceive = moment(this.props.lastReceive)
            const daysFromRevieve = now.diff(lastReceive, 'days')
            cooldown = interval - daysFromRevieve
        }

        const hasCooldown = cooldown > 0

        return (
            <div className={styles.wrapper}>
                <StepCSSTransitionGroup level={index}>
                    <div className={styles.background}>
                        <div className={styles.innerWrapper}>
                            <div className={`${styles.header} ${(isAvailable && !hasCooldown) ? '' : styles.disabled}`}>
                                <div className={classnames(styles[`headerBackground-${offerId}`], {
                                    [styles.headerBackgroundDisabled]: !(isAvailable && !hasCooldown)
                                })} />
                                <div className={styles.title}>
                                    {title}
                                </div>

                                {!!interval ? (
                                    <div className={styles.interval}>
                                        <Interpolate
                                            i18nKey={x('Доступно 1 раз в %(interval)s дней')}
                                            interval={interval}
                                            t={t}
                                        />
                                    </div>
                                ) : (
                                        <div className={styles.interval}>
                                            {t('Доступно любое количество')}
                                        </div>
                                    )}

                                {hasCooldown ? (
                                    <div className={styles.cooldown} >
                                        <Interpolate
                                            i18nKey={x('Через %(cooldown)s д.')}
                                            cooldown={cooldown}
                                            t={t}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <div className={styles.descr}>
                                {description}
                            </div>
                            <div className={styles.price}>
                                {t('Стоимость')}
                                <Currency
                                    amount={price}
                                    color="#fff"
                                    isBold
                                    type="oil"
                                />
                            </div>
                        </div>
                        {(isAvailable && canDistribute) ? (
                            <div className={styles.buttonRow}>
                                <div className={styles.notForAllWrapper}>
                                    <DivTooltip
                                        tooltipBody={this.renderBuyButtonTooltip(cooldown, haveEnoughMoney, needOil)}
                                    >
                                        <Button
                                            isDisabled={!haveEnoughMoney || isPending || hasCooldown}
                                            onClick={onBuy}
                                        >
                                            {t('Приобрести')}
                                        </Button>
                                    </DivTooltip>
                                </div>
                            </div>
                        ) : (
                                canDistribute ? (
                                    <div className={styles.warningRow}>
                                        <Message
                                            style="inline"
                                            type="error"
                                        >
                                            {t('Необходимо улучшить Казначейство')}
                                        </Message>
                                        <div className={styles.buttonPlaceholder}>
                                            {this.props.canBuyNextLevel ? (
                                                <DivTooltip
                                                    tooltipBody={(
                                                        <TooltipBody>
                                                            {t('Достаточно средств для постройки улучшения. Перейти к постройке.')}
                                                        </TooltipBody>
                                                    )}
                                                >
                                                    <div className={styles.upgradeTreasuryButton} onClick={this.props.navigateToTreasuryBuilding} />
                                                </DivTooltip>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : (
                                        <div className={classnames(styles.warningRow, styles.infoRow)}>
                                            <Message
                                                style="inline"
                                                type="none"
                                            >
                                                {t('Купить контейнеры могут только командующий и его заместители')}
                                            </Message>
                                        </div>
                                    )
                            )}
                    </div>
                </StepCSSTransitionGroup>
            </div>
        )
    }
}
